"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAuthConfiguration = void 0;
const next_auth_1 = __importDefault(require("next-auth"));
const uuid_1 = require("uuid");
const providers_1 = require("./common/providers");
const callbacks_1 = require("./common/callbacks");
const defaultSession = {
    strategy: 'jwt',
    maxAge: 60 * 5,
    updateAge: 24 * 60 * 60,
    generateSessionToken: () => (0, uuid_1.v4)(), // Use UUIDs for session tokens
};
const defaultCallbacks = {
    signIn: () => __awaiter(void 0, void 0, void 0, function* () { return true; }),
    redirect: (url) => url,
    session: (session) => __awaiter(void 0, void 0, void 0, function* () { return session; }),
    jwt: (token) => __awaiter(void 0, void 0, void 0, function* () { return token; }),
};
function generateAuthConfiguration(config, options = {}) {
    const { okta, session = {}, callbacks = {} } = config;
    const authOptions = Object.assign({ providers: (0, providers_1.generateProviders)(okta), callbacks: (0, callbacks_1.generateCallbacks)(Object.assign({}, defaultCallbacks, callbacks), okta), session: Object.assign({}, defaultSession, session) }, options);
    return {
        authOptions,
        nextAuth: (0, next_auth_1.default)(authOptions),
    };
}
exports.generateAuthConfiguration = generateAuthConfiguration;
//# sourceMappingURL=config.js.map